export function parseVersion(version: string | undefined): string | undefined {
  return version
    ?.replace("/identity-service/", "")
    ?.replace("/index.js", "")
    ?.replace(/^v/, "");
}
